import { ArrowPathIcon, ExclamationTriangleIcon, useCallback } from "@";

const ErrorAlert = ({
  show,
  title = "فشل تحميل البيانات",
  reload,
  isFixed = true,
  className = "",
}) => {
  const handleClick = useCallback(() => {
    if (reload) {
      reload();
    }
  }, [reload]);

  if (!show) return null;

  return (
    <div
      role="alert"
      onClick={handleClick}
      className={`group ${
        isFixed
          ? "fixed end-1/2 top-3 z-50 w-[95%] -translate-x-1/2 sm:w-fit"
          : ""
      } ${className}`}
    >
      <div
        className={`relative flex flex-col items-start gap-2 overflow-hidden rounded-2xl border border-red-100 bg-white/95 px-4 py-3 ps-5 shadow-xl shadow-red-900/5 backdrop-blur-md ${
          isFixed ? "animate-[errorAlertIn_0.3s_ease-out]" : ""
        } dark:border-red-900/40 dark:bg-gray-800/95 dark:shadow-black/30 md:flex-row md:items-center md:gap-3`}
      >
        {/* Start-side accent stripe */}
        <span
          aria-hidden
          className="pointer-events-none absolute start-0 top-0 h-full w-1 bg-gradient-to-b from-red-400 to-red-600 dark:from-red-500 dark:to-red-700"
        />

        <div className="relative flex items-center gap-2.5">
          {/* Icon chip */}
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-red-400 to-red-600 text-white shadow-md shadow-red-700/25 ring-1 ring-red-500/20 dark:from-red-500 dark:to-red-700">
            <ExclamationTriangleIcon className="h-5 w-5" />
          </span>
          <p className="text-[15px] font-semibold tracking-tight text-red-900 dark:text-red-100">
            {title}
          </p>
        </div>

        {reload && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleClick();
            }}
            className="group/retry relative inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-2xl border border-red-300 bg-white/70 px-3 py-1.5 text-sm font-semibold text-red-900 transition-all duration-200 hover:-translate-y-px hover:bg-red-50 hover:shadow-sm hover:shadow-red-700/10 active:translate-y-0 dark:border-red-700/50 dark:bg-red-950/40 dark:text-red-200 dark:hover:bg-red-900/40 md:ms-1"
          >
            <ArrowPathIcon className="h-4 w-4 transition-transform duration-500 group-hover/retry:-rotate-180" />
            إعادة المحاولة
          </button>
        )}
      </div>

      <style>{`@keyframes errorAlertIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};

export default ErrorAlert;
